import { render, staticRenderFns } from "./ImageSizes.vue?vue&type=template&id=4704a3b8"
import script from "./ImageSizes.vue?vue&type=script&lang=js"
export * from "./ImageSizes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports